/**
 * UUID (v4) for React keys and DOM ids via the Web Crypto API.
 * Server entry assigns global.crypto from node:crypto on Node 16 (see server.js).
 */
export function randomUuidKey(prefix = '') {
  const id = crypto.randomUUID();
  return prefix ? `${prefix}${id}` : id;
}
